<template>
  <div>
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="班次" prop="payMethod">
        <sl-select :data="shifts" v-model="form.shift" />
      </FormItem>
    </Form>
    <div style="text-align: right;padding-top:8px;">
      <Button @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </div>
</template>
<script>

export default {
  // left315 x top370  168x168
  data() {
    return {
      rules: {
        shift: [{ type: 'number', required: true, message: '请选择班次', trigger: 'blur,change' }],
      },
      form: {
        shift: null,
      },
      data: '',
      shifts:[
        {label:'小铁骑早高峰',value:1},
        {label:'大铁骑早高峰',value:2}
      ]
    }
  },

  mounted() {

  },

  methods: {
    init(id) {
      
    },

    save() {
      let params = { ...this.form }
      this.$emit('close' , params.shift)
      
    },

    handleSubmit(name) {

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })

    }
  }
}

</script>
